export default __webpack_public_path__ + "static/media/build6.2ef1edcd.png";